export const copyToClipboard = async (text: string): Promise<null | string> => {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    return 'Unable to copy to clipboard';
  }

  return null;
};
